import React from "react";

const LinkedinIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0,0,256,256"
    width={props.width || 32}
    height={props.height || 32}
    fill-rule="nonzero"
  >
    <g transform="translate(-64,-64) scale(1.5,1.5)">
      <g
        fill="#000000"
        fill-rule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
      >
        <g transform="scale(5.12,5.12)">
          <path d="M25,9c-8.822,0 -16,7.178 -16,16c0,8.822 7.178,16 16,16c8.822,0 16,-7.178 16,-16c0,-8.822 -7.178,-16 -16,-16zM25.02148,10.00391c8.27,0 15,6.729 15,15c0,8.271 -6.729,15 -15,15c-8.271,0 -15,-6.729 -15,-15c0,-8.271 6.729,-15 15,-15zM19.33203,16.63281c-0.775,0 -1.40234,0.6293 -1.40234,1.4043c0,0.775 0.62734,1.4043 1.40234,1.4043c0.775,0 1.4043,-0.6293 1.4043,-1.4043c0,-0.775 -0.6293,-1.4043 -1.4043,-1.4043zM18.86914,21.54492c-0.519,0 -0.93945,0.42045 -0.93945,0.93945v8.64844c0,0.519 0.42045,0.93945 0.93945,0.93945h0.92773c0.519,0 0.93945,-0.42045 0.93945,-0.93945v-8.64844c0,-0.519 -0.42045,-0.93945 -0.93945,-0.93945zM24.47266,21.54492c-0.512,0 -0.92773,0.41573 -0.92773,0.92773v8.67188c0,0.512 0.41573,0.92773 0.92773,0.92773h0.95313c0.512,0 0.92578,-0.41573 0.92578,-0.92773v-4.33594c0,-1.351 1.10603,-2.45508 2.45703,-2.45508c1.351,0 2.45508,1.10408 2.45508,2.45508v4.33594c0,0.512 0.41573,0.92773 0.92773,0.92773h0.95313c0.512,0 0.92578,-0.41573 0.92578,-0.92773v-5.03711c0,-2.52 -2.04055,-4.5625 -4.56055,-4.5625c-1.226,0 -2.3392,0.48644 -3.1582,1.27344v-0.3457c0,-0.512 -0.41378,-0.92773 -0.92578,-0.92773z"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default LinkedinIcon;
